// Layer 4 (UI) — the flagged risks beside the heat map (polish.P20, comp A
// `.fl`): ranked rows divided by hairlines — rank numeral (crimson for the
// first), id and name, band chip and score, the control measure, the owner
// chip and the failure-mode tag. Renders `riskFlags()` only.

import { cn } from '@/shared/cn';
import { riskFlags } from './RiskFlagList.transform';
import { BandChip, FailureModeTag, IdCode, OwnerChip } from './risk-ui';

export function RiskFlagList() {
  const flags = riskFlags();
  return (
    <div data-risk-flags>
      <div className="flex items-center justify-between text-[10px] font-semibold uppercase tracking-[0.07em] text-muted">
        <span>Flagged · score 9 and above</span>
        <span>by score</span>
      </div>
      <ol className="divide-y divide-[var(--color-divider)]">
        {flags.map((flag) => (
          <li
            key={flag.id}
            data-flag={flag.id}
            className="grid grid-cols-[16px_minmax(0,1fr)_auto] items-baseline gap-x-2.5 gap-y-0.5 py-2"
          >
            <span
              className={cn(
                'row-span-3 text-[13px] font-semibold tabular-nums',
                flag.rank === 1 ? 'text-[var(--color-accent-500)]' : 'text-muted',
              )}
            >
              {flag.rank}
            </span>
            <span className="text-[13px] font-semibold leading-tight text-ink-primary">
              <IdCode className="mr-1.5">{flag.id}</IdCode>
              {flag.label}
            </span>
            <span className="flex items-center gap-1.5 whitespace-nowrap">
              <BandChip band={flag.band} label={flag.bandLabel} />
              <span className="text-[13px] font-semibold tabular-nums text-ink-primary">{flag.score}</span>
            </span>
            <span className="col-span-2 col-start-2 text-xs leading-snug text-ink-secondary">{flag.controlMeasure}</span>
            <span className="col-span-2 col-start-2 mt-0.5 flex flex-wrap items-center gap-1.5">
              <OwnerChip>{flag.ownerTeam}</OwnerChip>
              {flag.failureModeLabel ? <FailureModeTag>{flag.failureModeLabel}</FailureModeTag> : null}
            </span>
          </li>
        ))}
      </ol>
    </div>
  );
}
